import React from "react";
import PageLayout from "../../components/PageLayout";

export default function About() {
  return (
    <PageLayout>
      <div className="container">
        <div className="aboutMain">
          <div className="aboutleft">
            <h2 className="titletwo">
              About <span> Paths</span>
            </h2>
            <p>
              Social media has evolved far beyond its original purpose: a space
              to collect and share your thoughts, memories, and experiences with
              family and friends.
            </p>
            <p>
              Founder Taber Nash recognized a growing need for a return to those
              roots—a place to collaborate with loved ones and preserve life’s
              experiences in an innovative, easy-to-manage digital format.  
            </p>
            <p>
              The result was PATHS. With its unique map-like timeline and
              seamless integration with existing social media platforms, PATHS
              allows you to easily import, create, share, and organize the
              events, photos, videos, and experiences you choose. It serves as a
              secure and organized repository of your life online.
            </p>
            <p>
              Additionally, PATHS weaves your story together with those of close
              friends and family, creating a rich, interconnected narrative of
              the journey you’ve walked. After all, every story is made more
              meaningful by the key characters who share it with you.
            </p>
          </div>
          <div className="aboutright">
            <img
              src="../images/aboutPicture.png"
              alt="About Paths"
              className="img-fluid"
            />
          </div>
        </div>

        <div className="about-meeting">
          <p>
            “Years ago, I was sitting in a meeting, listening to someone speak
            about their life and its significance. As I sat there, I began
            reflecting on my own life—the places I’ve lived, the experiences
            I’ve had, the destinations I’ve traveled to, the many people I’ve
            crossed paths with, and the memories we’ve created together. I also
            realized how meaningful it was to be in that meeting, at that exact
            moment, with those specific people, in that particular time and
            place.
          </p>
          <p>
            I reminded myself that with nearly eight billion people on Earth,
            the individuals we encounter are far more significant than we often
            realize. I left that meeting with a renewed and exciting motivation
            to record my life’s story—not just for myself, but for my children
            and future generations. I wanted them to know who I truly am and to
            learn from my experiences.
          </p>
          <p>
            The challenge, however, was finding a platform where I could
            document my life in a way that was fun, social, and collaborative,
            just as I had envisioned. That’s when the idea for PATHS was born.”
          </p>
          <p>— Taber Nash, Founder</p>
        </div>
      </div>
    </PageLayout>
  );
}
